export interface CsvImportUserError {
  name?: string;
  email?: string;
  errorFields: UserErrorField[];
}

export interface CsvImportUsersErrorResponse {
  importErrors: CsvImportUserError[];
}

export enum UserErrorField {
  NAME = 'NAME',
  EMAIL = 'EMAIL',
  DUPLICATE_NAME = 'DUPLICATE_NAME',
  DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
}
